import SocketIOProvider from './SocketIOProvider'

const StoreSocket = {
  enterStore: function (storeId) {
    this.emit('enter store', storeId)
  },
  onProductStockUpdate: function (handler) {
    this.on('stock update', handler)
  },
  offProductStockUpdate: function (handler) {
    this.off('stock update', handler)
    this.removeAllListeners('stock update')
  },
  onStoreStockSettingChanged: function (handler) {
    this.on('store stock setting changed', handler)
  },
  onStoreShippingSettingChanged: function (handler) {
    this.on('store shipping setting changed', handler)
  },
  onProductStockSettingChanged: function (handler) {
    this.on('product stock setting changed', handler)
  },
  onProductShippingSettingChanged: function (handler) {
    this.on('product shipping setting changed', handler)
  }
}

const socketIOProvider = SocketIOProvider('/enterStore')
export default Object.assign(socketIOProvider, StoreSocket)
